/*
    FIREBASE.JS

    - Last updated: 17.10.18
    - NOTES:
		https://github.com/firebase/firebase-js-sdk/issues/848
*/

import * as firebase from 'firebase/app';
import 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const firebaseConfig = {
	apiKey: "AIzaSyBydsROj-jVU4NYkGRbfdg4iH4rm75HZ3s",
	authDomain: "kleptobreaker.firebaseapp.com",
	databaseURL: "https://kleptobreaker.firebaseio.com",
	projectId: "kleptobreaker",
	storageBucket: "",
	messagingSenderId: "1086494824279"
};

firebase.initializeApp(firebaseConfig);

export default firebase;